import { observer } from 'mobx-react-lite'
import styled from '@emotion/styled'
import { Stack } from '@mui/material'
import MobileLayoutWrapper from 'Components/Elements/UserAccountMenu/MobileLayoutWrapper'
import Breadcrumb from 'Components/Elements/UserAccountMenu/Breadcrumb'

const SavedCreditCardMobileWrapper = observer(({ children }) => {
    return (
        <MobileLayoutWrapper>
            <StackMobileLayout>
                <Breadcrumb />
                {children}
            </StackMobileLayout>
        </MobileLayoutWrapper>
    )
})
const StackMobileLayout = styled(Stack)`
    width: 100%;
`
export default SavedCreditCardMobileWrapper
